module.exports = __webpack_public_path__ + "static/media/marketing_img_animalCards_iso.8ce8e320.png";